import { render } from "./column-rating-pool.vue?vue&type=template&id=2f957c63"
import script from "./column-rating-pool.vue?vue&type=script&lang=js"
export * from "./column-rating-pool.vue?vue&type=script&lang=js"

import "./column-rating-pool.vue?vue&type=style&index=0&id=2f957c63&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__